import BookingAppBar from '@components/AppBar/BookingAppBar';
import LoadableContainer from '@components/LoadableContainer';
import ModalContainer from '@components/ModalContainer';
import SplashScreen from '@components/SplashScreen';
import { useAppDispatch, useAuthState, useBusinessState } from '@core/configureStore';
import { openModal } from '@core/features';
import { Layout } from 'antd';
import React, { useEffect } from 'react';
import { DataAttributes, useIntercom } from 'react-use-intercom';
import BookingManagementContent from '@components/BookingManagementContent';
import { fetchLocationData } from '@core/features/business/thunks';
import { fetchSelectedLocation } from '@core/features/business/thunks/fetchSelectedLocation.thunk';

type Props = {};

const BookingManagementScreen = (props: Props) => {
  const dispatch = useAppDispatch();
  const { user, isAuthLoading: isLoadingUser } = useAuthState();
  const { error } = useBusinessState();
  const { update } = useIntercom();

  useEffect(() => {
    if (!isLoadingUser && !user?.selected_location) {
      dispatch(
        openModal({
          modalName: 'welcomeLocationModal',
        })
      );
    }
  }, [error, user]);

  useEffect(() => {
    if (user && !isLoadingUser) {
      let intercomData: DataAttributes = {
        email: user.email,
        userId: user.id.toString(),
        name: `${user.given_name} ${user.family_name}`,
      };

      if (user.selected_location) {
        intercomData = {
          ...intercomData,
          customAttributes: {
            Location: user.selected_location.title,
          },
        };
      }
      update(intercomData);
    }
  }, [user]);

  useEffect(() => {
    const init = () => {
      dispatch(fetchSelectedLocation());
      dispatch(fetchLocationData());
    };
    init();
  }, []);
  return (
    <React.Fragment>
      <LoadableContainer isLoading={!user} loadComponent={<SplashScreen />}>
        <Layout style={{ height: '100vh', overflow: 'auto' }}>
          <Layout.Content>
            <BookingAppBar />
            <BookingManagementContent />
          </Layout.Content>
          {/* {!isMobile && <BookingAppSider />} */}
          <ModalContainer />
        </Layout>
      </LoadableContainer>
    </React.Fragment>
  );
};

export default BookingManagementScreen;
